module.exports = __webpack_public_path__ + "img/infinitywarscard.47b8d581.jpg";